var NbRoleProvider = /** @class */ (function () {
    function NbRoleProvider() {
    }
    return NbRoleProvider;
}());
export { NbRoleProvider };
//# sourceMappingURL=role.provider.js.map